import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./App.css";
import "./i18n.jsx";
import i18n from "./i18n.jsx";
import { I18nextProvider } from "react-i18next";

// TEMPORARY FIX: Disabled StrictMode to prevent double rendering issues
// that may cause infinite loops with input focus events
// TODO: Re-enable after fixing all useEffect dependencies
import { HelmetProvider } from 'react-helmet-async';
import { DebugErrorBoundary } from './debug';

// TEMPORARY FIX: Disabled StrictMode to prevent double rendering issues
// that may cause infinite loops with input focus events
// TODO: Re-enable after fixing all useEffect dependencies
ReactDOM.createRoot(document.getElementById("root")).render(
  <DebugErrorBoundary>
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </I18nextProvider>
    </HelmetProvider>
  </DebugErrorBoundary>
);